import React, { useState } from 'react';

// Components
import {
  Cross,
  ModalContent,
  Icon,
  Text,
  Button,
  UploadFile,
  Conditional,
  Space,
  Loader,
} from '@cashfree-intl/coherent';

// Constants
import { CANCELLED_CHEQUE_FILE_SIZE_LIMIT, CHECKLIST } from '../constants';

// Types
import { CancelledChequeModalProps } from '../types';

// Styled
import { StyledCancelledChequeModal } from '../styled';

// Hooks
import { useTheme } from 'styled-components';
import useDocActions from 'hooks/useDocActions';

const CancelledChequeModal = ({
  onClose,
  onSubmit,
  accountName,
  chequeDetails,
  loading,
  handleUploadChange,
}: CancelledChequeModalProps) => {
  const { COLORS }: any  = useTheme();
  const {previewDoc}=useDocActions()
  const [page, setPage] = useState(0);
  const goToFirstPage = () => setPage(0);
  const goToSecondPage = () => setPage(1);

  return (
    <StyledCancelledChequeModal open $maxWidth={432} data-testid="cancelled-cheque-modal">
      <Loader active={loading} loadingText="Uploading" />
      <ModalContent>
        <div className="close-icon">
          <Cross onClick={onClose} stroke={COLORS.body} opacity={0.3} />
        </div>
        <Conditional if={page === 0}>
          <div className="error-icon">
            <Icon name="ERROR" />
          </div>
          <Text variant="h16" className="subtitle">
            Name on PAN & Bank a/c does’t match
          </Text>
          <Text variant="h20" className="title">
            Please upload a cancelled cheque of {accountName}
          </Text>
          <UploadFile
            type="primary"
            buttonText="Upload"
            checkList={CHECKLIST}
            accept=".png, .jpeg, .pdf"
            onChange={payload => {
              handleUploadChange(payload, 'cheque_selfServe');
            }}
            uploaded={!!chequeDetails?.name && chequeDetails}
            disabled={chequeDetails?.locked}
            sizeLimit={CANCELLED_CHEQUE_FILE_SIZE_LIMIT}
            showPreview={previewDoc(chequeDetails)}
          />
          <Button primary onClick={goToSecondPage} className="mt-4" disabled={!chequeDetails?.name} data-testid="submit-button">
            Submit
          </Button>
        </Conditional>
        <Conditional if={page === 1}>
        <div className="cancelled-cheque-img" />
          <Text variant="h20" className="title mt-2">
            Please ensure the name of {accountName} is printed on it.
          </Text>
          <Space justifyContent="flex-end" className="footer">
            <Button link onClick={goToFirstPage} data-testid="re-upload-button">
              Re-upload
            </Button>
            <Button primary onClick={onSubmit} className="ml-1" data-testid="submit-now-button">
              Submit Now
            </Button>
          </Space>
        </Conditional>
      </ModalContent>
    </StyledCancelledChequeModal>
  );
};

export default CancelledChequeModal;
